export const dataBarChart = [
  { name: "Cy", value: 660300 },
  { name: "S&P 500", value: 547000 },
];

export const dataBarChartZero = [
  { name: "Cy", value: 0 },
  { name: "S&P 500", value: 0 },
];

export const dataLineChart = [
  { year: 2000, Cy: 400000, "S&P 500": 240000 },
  { year: 2001, Cy: 300000, "S&P 500": 139800 },
  { year: 2002, Cy: 980000, "S&P 500": 500000 },
  { year: 2003, Cy: 690800, "S&P 500": 278000 },
  { year: 2004, Cy: 480000, "S&P 500": 189000 },
  { year: 2005, Cy: 380000, "S&P 500": 239000 },
  { year: 2006, Cy: 430000, "S&P 500": 349000 },
  { year: 2007, Cy: 675000, "S&P 500": 542000 },
  { year: 2008, Cy: 420000, "S&P 500": 333000 },
  { year: 2009, Cy: 648000, "S&P 500": 425000 },
  { year: 2010, Cy: 421000, "S&P 500": 341000 },
  { year: 2011, Cy: 398000, "S&P 500": 254000 },
  { year: 2012, Cy: 888000, "S&P 500": 624000 },
  { year: 2013, Cy: 390000, "S&P 500": 352000 },
  { year: 2014, Cy: 657000, "S&P 500": 567000 },
  { year: 2015, Cy: 256000, "S&P 500": 156000 },
  { year: 2016, Cy: 634000, "S&P 500": 527000 },
  { year: 2017, Cy: 630000, "S&P 500": 456000 },
];

export const dataLineChartZero = [
  { year: 2000, Cy: 0, "S&P 500": 0 },
  { year: 2001, Cy: 0, "S&P 500": 0 },
  { year: 2002, Cy: 0, "S&P 500": 0 },
  { year: 2003, Cy: 0, "S&P 500": 0 },
  { year: 2004, Cy: 0, "S&P 500": 0 },
  { year: 2005, Cy: 0, "S&P 500": 0 },
  { year: 2006, Cy: 0, "S&P 500": 0 },
  { year: 2007, Cy: 0, "S&P 500": 0 },
  { year: 2008, Cy: 0, "S&P 500": 0 },
  { year: 2009, Cy: 0, "S&P 500": 0 },
  { year: 2010, Cy: 0, "S&P 500": 0 },
  { year: 2011, Cy: 0, "S&P 500": 0 },
  { year: 2012, Cy: 0, "S&P 500": 0 },
  { year: 2013, Cy: 0, "S&P 500": 0 },
  { year: 2014, Cy: 0, "S&P 500": 0 },
  { year: 2015, Cy: 0, "S&P 500": 0 },
  { year: 2016, Cy: 0, "S&P 500": 0 },
  { year: 2017, Cy: 0, "S&P 500": 0 },
];



// WEBPACK FOOTER //
// ./src/components/Charts/CySampleData.js